module.exports = __webpack_public_path__ + "img/ruStub.c929f4ec.png";